// extracted by mini-css-extract-plugin
export default {"root":"FeedbackWidget_root__OOM6N","star":"FeedbackWidget_star__HlVaL"};